import React, { useMemo } from "react";
import { Select } from "antd";

import { fullName } from "helper/util";

// Searchable driver picker: case-insensitive match on name or email.
// Clearing it calls onChange(undefined), i.e. "unassigned".
const DriverSearchSelect = ({
  drivers = [],
  value,
  onChange,
  loading,
  placeholder = "Assign driver",
  showInternalTag = false,
  ...rest
}) => {
  const options = useMemo(
    () =>
      drivers.map((driver) => ({
        value: driver.id,
        label: `${fullName(driver)}${driver.email ? ` (${driver.email})` : ""}${
          showInternalTag && driver.isInternalDriver ? " · Internal" : ""
        }`,
        searchText: `${driver.firstName || ""} ${driver.lastName || ""} ${
          driver.email || ""
        }`.toLowerCase()
      })),
    [drivers, showInternalTag]
  );

  return (
    <Select
      showSearch
      allowClear
      placeholder={placeholder}
      value={value || undefined}
      onChange={(driverId) => onChange && onChange(driverId || undefined)}
      loading={loading}
      options={options}
      filterOption={(input, option) =>
        option?.searchText?.includes((input || "").trim().toLowerCase())
      }
      style={{ width: "100%" }}
      {...rest}
    />
  );
};

export default DriverSearchSelect;
